<div class="container">
  <div class="container__title">
    <h1 class="title" translate>Be a picture book hero</h1>
  </div>
  <div class="container__content">
    <p class="content" translate>Special books made from kids name and birthday</p>
  </div>
  <div class="container__button">
    <button
      class="button"
      (click)="onButtonClick()"
    >
      <span class="button__text" translate>See all books</span>
    </button>
  </div>
</div>
